"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * is element inside the current browser viewport
 */
function visible(element) {
    if (element) {
        var scrollX_1 = document.documentElement.scrollLeft;
        var scrollY_1 = document.documentElement.scrollTop;
        var rect = shiftRect(element.getBoundingClientRect(), { x: scrollX_1, y: window.scrollY });
        var top_1 = scrollY_1;
        var left = scrollX_1;
        var width = window.innerWidth;
        var height = window.innerHeight;
        var windowRect = {
            top: top_1, left: left, width: width, height: height,
            right: left + width,
            bottom: top_1 + height
        };
        return intersects(rect, windowRect);
    }
    return false;
}
exports.visible = visible;
function shiftRect(rect, distance) {
    return {
        top: rect.top + distance.y,
        bottom: rect.bottom + distance.y,
        left: rect.left + distance.x,
        right: rect.right + distance.x,
        width: rect.width,
        height: rect.height
    };
}
function intersects(r1, r2) {
    var disjoined = r1.bottom < r2.top || r1.top > r2.bottom ||
        r1.right < r2.left || r1.left > r2.right;
    return !disjoined;
}
//# sourceMappingURL=visible.js.map